var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 411 411",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.015.095h410v410h-410z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.993 130.655c-44.416 0-87.153 17.592-118.684 49.123l-.498.498 66.518 9.529 52.664-59.15Z",
    style: {
      fill: "#f3f3f1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.409 331.088c-13.355 13.355-82.418 34.034-82.418 34.034s20.679-69.063 34.034-82.418c13.354-13.354 35.029-13.354 48.384 0 13.368 13.355 13.368 35.015 0 48.384Z",
    style: {
      fill: "#ffd615",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.991 269.122c0-33.593-31.062-59.932-66.034-51.868-19.712 4.551-35.484 20.906-39.509 40.732-4.679 23.054 5.561 44.004 22.741 55.367 7.566 5.006 11.676 13.867 11.676 22.941v18.275c0 6.941 3.67 10.539 8.207 10.539h19.143a8.2 8.2 0 0 0 8.206-8.206v-20.267c0-9.159 3.996-18.219 11.634-23.268 14.407-9.486 23.936-25.699 23.936-44.245Z",
    style: {
      fill: "#f3f3f1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.34 114.536c9.712-9.711 25.481-9.711 35.193 0 9.712 9.712 9.712 25.482 0 35.193-9.712 9.712-25.481 9.712-35.193 0-9.712-9.711-9.712-25.481 0-35.193Z",
    style: {
      fill: "#f3f3f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.09 222.715c43.791-40.732 75.833-102.158 79.531-161.863.54-8.733-6.642-15.915-15.374-15.374-62.848 3.897-127.886 39.025-168.363 86.385L122.9 196.816c-5.02 5.632-4.779 14.194.555 19.527l70.3 70.301c5.334 5.333 13.895 5.575 19.527.555l54.784-48.911c4.495-6.329 10.283-11.705 17.024-15.573Zm-24.704-108.188c9.714-9.714 25.472-9.714 35.2 0 9.728 9.713 9.714 25.472 0 35.2-9.713 9.728-25.472 9.713-35.2 0-9.728-9.714-9.713-25.487 0-35.2Z",
    style: {
      fill: "#ffd615",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.811 180.276.498-.498c22.997-22.997 51.996-38.485 83.214-45.227l3.47-3.896c-44.416 0-87.153 17.592-118.684 49.123l-.498.498 66.518 9.529 3.626-4.068-38.144-5.461Z",
    style: {
      fill: "#d5dbe1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.025 282.704c2.46-2.46 5.262-4.309 8.192-5.873-12.928-6.884-29.298-5.035-40.192 5.873-13.355 13.355-34.034 82.418-34.034 82.418s16.967-5.091 35.712-11.833c6.556-20.323 20.437-60.7 30.322-70.585Z",
    style: {
      fill: "#dcb400",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.386 149.727c-9.713-9.714-9.713-25.472 0-35.2.498-.498 1.067-.854 1.593-1.309-9.785-8.277-24.377-7.922-33.593 1.309-9.713 9.713-9.713 25.472 0 35.2 9.216 9.216 23.823 9.585 33.593 1.308-.526-.455-1.095-.811-1.593-1.308ZM324.102 354.583v-18.275c0-9.074-4.11-17.934-11.677-22.941-17.18-11.377-27.42-32.312-22.741-55.367 3.826-18.887 18.375-34.503 36.779-39.879-8.505-2.474-17.806-3.086-27.492-.853-19.712 4.551-35.484 20.907-39.509 40.732-4.679 23.055 5.561 44.004 22.741 55.367 7.566 5.007 11.677 13.867 11.677 22.941v18.275c0 6.941 3.669 10.539 8.206 10.539h19.143c2.219 0 4.224-.896 5.703-2.332-1.707-1.764-2.83-4.452-2.83-8.207Z",
    style: {
      fill: "#d5dbe1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.677 216.358c-5.333-5.334-5.575-13.895-.555-19.527l57.984-64.953c35.883-41.984 91.051-74.24 146.887-83.769-2.531-1.678-5.432-2.83-8.746-2.631-62.848 3.897-127.886 39.025-168.363 86.385L122.9 196.816c-5.02 5.632-4.779 14.194.555 19.527l70.3 70.301c5.334 5.333 13.895 5.575 19.527.555l5.945-5.305-65.55-65.536Z",
    style: {
      fill: "#dcb400",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.284 306.811a10.64 10.64 0 0 1-7.538-3.129l-89.315-89.315c-3.997-3.997-4.182-10.425-.413-14.635l66.845-74.951c.697-.811 1.095-1.266 1.55-1.735 48.028-55.168 122.951-90.212 190.834-88.591 5.689.143 10.282 4.722 10.41 10.425.996 44.331-13.582 92.331-41.088 135.14l-17.948-11.534c23.04-35.869 36.196-75.463 37.618-112.612-58.112 2.318-122.909 34.247-164.253 81.721-.782.896-1.18 1.351-1.635 1.82l-59.719 66.987 75.05 75.051 57.036-51.024 14.222 15.9-64.545 57.751a10.62 10.62 0 0 1-7.111 2.731Z",
    style: {
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.621 168.486c-8.598 13.801-18.839 28.26-30.885 43.44h28.642c7.663-11.131 14.323-21.729 20.191-31.906l-17.948-11.534Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m127.807 200.358-66.518-9.529a10.65 10.65 0 0 1-8.604-7.182 10.628 10.628 0 0 1 2.588-10.909c33.693-33.692 79.702-52.736 126.72-52.736v21.333c-34.076 0-67.555 11.364-94.634 31.702l43.491 6.229-3.043 21.092ZM44.991 375.789a10.625 10.625 0 0 1-7.538-3.129 10.645 10.645 0 0 1-2.674-10.61c3.584-11.961 22.201-72.377 36.722-86.898 16.939-16.953 46.521-16.953 63.474 0 17.479 17.494 17.479 45.967 0 63.46-14.521 14.521-74.951 33.138-86.912 36.722-1.01.313-2.048.455-3.072.455Zm58.24-92.445a23.529 23.529 0 0 0-16.654 6.884c-6.201 6.201-16.882 33.621-25.188 58.482 24.86-8.306 52.295-18.987 58.482-25.188 9.173-9.187 9.173-24.121 0-33.294a23.498 23.498 0 0 0-16.64-6.884ZM321.229 375.789h-19.143c-9.373 0-18.873-7.282-18.873-21.206v-18.289c0-5.846-2.645-11.236-6.898-14.038-21.831-14.464-32.554-40.519-27.306-66.389 4.835-23.851 23.95-43.548 47.559-48.996 19.513-4.465 39.552-.071 54.912 12.16 15.374 12.232 24.177 30.493 24.177 50.105 0 21.419-10.737 41.302-28.714 53.163-4.224 2.788-6.841 8.292-6.841 14.364v20.253c0 10.411-8.477 18.873-18.873 18.873Zm-16.683-21.334h14.223v-17.792c0-13.34 6.144-25.372 16.426-32.17 11.975-7.908 19.129-21.134 19.129-35.371 0-13.07-5.874-25.259-16.128-33.408-10.268-8.149-23.694-11.093-36.835-8.064-15.616 3.598-28.246 16.64-31.446 32.455-3.57 17.579 3.385 34.574 18.162 44.359 10.311 6.813 16.469 18.717 16.469 31.83v18.161ZM277.993 167.675c-9.5 0-18.432-3.698-25.144-10.411-13.867-13.866-13.867-36.423 0-50.289 13.397-13.426 36.821-13.44 50.275 0 13.867 13.866 13.867 36.423 0 50.289-6.713 6.713-15.644 10.411-25.131 10.411Zm0-49.764c-3.811 0-7.381 1.48-10.055 4.153-5.546 5.547-5.546 14.564 0 20.125 5.362 5.376 14.749 5.376 20.111 0 5.546-5.547 5.546-14.564 0-20.125a14.2 14.2 0 0 0-10.056-4.153Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.48cf806c20e2ec0420be8e7c10089887.svg";
export { ForwardRef as ReactComponent };